// extracted by mini-css-extract-plugin
module.exports = {"placeholderSize":"FSelect_placeholderSize__HPD4r"};